import React from 'react'

import { ZariContext } from '_zari/context'
import { Portlet, Row, Col, Button } from '_zari/core'

import * as AsientoContableService from 'services/asientosContables.service'

const portletBreadcrumbs = [
  { name: 'Estados Financieros' },
  { name: 'Cierre Clase 6-7-9' },
  { name: 'Cierre activo, pasivo y patrimonio' }
]

const CierreActivoPasivoPatrimonioSection = ({ validarSaldoCeroClases12345 }) => {
  const __zariContext = React.useContext(ZariContext)

  const clickGenerarAsientosCierre = React.useCallback(() => {
    __zariContext.loader.open('Generando asientos de cierre.')

    AsientoContableService.generarAsientosCierreActivoPasivoPatrimonio()
      .then(() => {
        __zariContext.snack('success', 'Asientos de cierre activo, pasivo y patrimonio.')
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext])

  React.useEffect(() => {
    setTimeout(() => {
      validarSaldoCeroClases12345()
    }, 500)
  }, [validarSaldoCeroClases12345])

  return (
    <Portlet>
      <Portlet.Header title='Estados Financieros' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>
        <Row>
          <Col md={12}>
            <Button onClick={clickGenerarAsientosCierre} tiny>
              Generar asientos de cierre activo, patrimonio y cierre
            </Button>
          </Col>
        </Row>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(CierreActivoPasivoPatrimonioSection)
